import { useEffect, useState } from "react";
import { getData } from "./Http/api";

const SujetoContactoPrioridad = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData("/SujetoPrioridadContactoListar");

        const data = response.value.map((item) => ({
          idSujetoPrioridadContacto: item.idSujetoPrioridadContacto,
          descripcion: item.descripcion,
          activo: item.activo,
          orden: item.orden
        }));

        setRows(data);
      } catch (ex) {
        console.error("Error cargando Prioridades de Contacto:", ex);
        setRows([]); // Devuelve array vacío si hay error
      }
    };

    fetchData();
  }, []);

  return rows;
};

// Named async helper for non-hook consumers
export const fetchSujetoContactoPrioridades = async () => {
  try {
    const response = await getData("/SujetoPrioridadContactoListar");
    return (response?.value || []).map((item) => ({
      idSujetoPrioridadContacto: item.idSujetoPrioridadContacto,
      descripcion: item.descripcion,
      activo: item.activo,
      orden: item.orden
    }));
  } catch (ex) {
    console.error("Error cargando Prioridades de Contacto (helper):", ex);
    return [];
  }
};

export default SujetoContactoPrioridad;
